export const secondLocationToFirstLocation = new Map<string, string>([
  ['GownPak2', 'Gown Pak'],
  ['Prep Tray2', 'Prep Tray'],
]);
